import { Box, Typography, Button, Paper } from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSapiensAuth } from '@sapiens/auth-react';
import { MainLayout } from '@/components/layout';

export function HomePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, isAuthenticated } = useSapiensAuth();

  return (
    <MainLayout>
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper sx={{ p: 4, textAlign: 'center', maxWidth: 500 }}>
          <HomeIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
          <Typography variant="h4" gutterBottom>
            {t('app.name')}
          </Typography>
          
          {isAuthenticated && user ? (
            <Box>
              <Typography variant="body1" color="text.secondary" mb={3}>
                Welcome, {user.name || user.email}!
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                <Button variant="contained" onClick={() => navigate('/profile')}>
                  {t('nav.profile')}
                </Button>
                {user.userType === 2 && (
                  <Button variant="outlined" onClick={() => navigate('/admin/users')}>
                    {t('nav.users')}
                  </Button>
                )}
                {user.userType === 2 && (
                  <Button variant="outlined" onClick={() => navigate('/admin/audit')}>
                    {t('nav.auditLog')}
                  </Button>
                )}
              </Box>
            </Box>
          ) : (
            <Box>
              <Typography variant="body1" color="text.secondary" mb={3}>
                {t('sso.description')}
              </Typography>
              <Button variant="contained" onClick={() => navigate('/login')}>
                {t('auth.login')}
              </Button>
            </Box>
          )}
        </Paper>
      </Box>
    </MainLayout>
  );
}
